/**
 * Утилита для безопасной загрузки изображений с поддержкой CORS
 */

export const loadImageSafely = (src: string): Promise<HTMLImageElement> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    
    // Устанавливаем crossOrigin для CloudFront изображений
    if (src.includes('cloudfront.net') || src.includes('amazonaws.com')) {
      img.crossOrigin = 'anonymous';
    }
    
    img.onload = () => resolve(img);
    img.onerror = (error) => {
      console.warn('Ошибка загрузки изображения:', src, error);
      // Пробуем загрузить без crossOrigin
      const imgFallback = new Image();
      imgFallback.onload = () => resolve(imgFallback);
      imgFallback.onerror = () => reject(new Error(`Не удалось загрузить изображение: ${src}`));
      imgFallback.src = src;
    };
    
    img.src = src;
  });
};

/**
 * Проверяет, поддерживает ли браузер cross-origin isolation
 */
export const isCrossOriginIsolated = (): boolean => {
  return document.crossOriginIsolated || false;
};

/**
 * Создает безопасный URL для изображения
 */
export const createSafeImageUrl = (url: string): string => {
  // Убираем добавление cors параметра, так как он может вызывать проблемы
  // if ((url.includes('cloudfront.net') || url.includes('amazonaws.com')) && isCrossOriginIsolated()) {
  //   // Добавляем параметр для обхода CORS
  //   const separator = url.includes('?') ? '&' : '?';
  //   return `${url}${separator}cors=true`;
  // }
  return url;
};

/**
 * Загружает изображение с fallback стратегией
 */
export const loadImageWithFallback = async (src: string): Promise<string> => {
  try {
    // Сначала пробуем загрузить с crossOrigin
    const img = await loadImageSafely(src);
    return src;
  } catch (error) {
    console.warn('Fallback загрузка изображения:', src);
    
    // Если не удалось, пробуем через прокси или без crossOrigin
    if (src.includes('cloudfront.net') || src.includes('amazonaws.com')) {
      // Можно добавить прокси URL здесь
      const proxyUrl = `/api/proxy-image?url=${encodeURIComponent(src)}`;
      return proxyUrl;
    }
    
    throw error;
  }
}; 